module.exports = __webpack_public_path__ + "static/media/paper.83e03134.png";